// eslint-disable-next-line import/prefer-default-export
export const COOKIES = [
  '__taidid',
  '__taisrl',
  '__taisdl',
  '__tai',
  '__taisid',
  '__tai*',
];
